// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { cn } from '@/lib/utils';
import { Eyebrow } from '@/components/greenlight/Eyebrow';

export interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  actions?: React.ReactNode;
  className?: string;
}

export function PageHeader({ eyebrow, title, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4', className)}>
      <div>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <h1 className="font-display text-2xl font-semibold leading-[1.1] tracking-[-0.02em] md:text-[28px]">
          {title}
        </h1>
      </div>
      {actions && <div className="hidden md:flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
